site:
  title: Affiliates system
  lang: en
modals:
  login:
    title: Log in
    submitButton: Log in
    resetLink: Reset you password
    signUpLink: Register
    or: or
  reset:
    title: Forgot your password?
    submitButton: Reset Password
  signUp:
    title: Register
    submitButton: Register
    termsText: I accept the
    termsLink: Affiliate Terms & Conditions
  notVerified:
    title: You have registered successfully.
    text: We will review your application and, if your account is verified, you will be notified via email.
  terms:
    title: AFFILIATE TERMS & CONDITIONS
whyUs:
  title: Why us?
  subtitle: Scale your income with up to 50% Revenue Share and industry-leading player retention tools.
  note: ''
  action:
    text: ''
  modifier: card--primary
  list:
    - id: whyus-1
      title: Dedicated Affiliate Managers
      text: Get 24/7 expert guidance to optimize your campaigns. We don’t just answer questions; we help you find new ways to boost your ROI and conversion rates.
      image: support
    - id: whyus-2
      title: Top Tier GEOs
      text: Monetize traffic from high-value markets. Our brands are fully localized with native languages and popular payment methods to ensure maximum conversion in the world's most profitable regions.
      image: countries
    - id: whyus-3
      title: Real-Time Data Tracking
      text: Make data-driven decisions with hourly updates. Track clicks, conversions, and revenue effortlessly through our advanced, transparent dashboard.
      image: stats
    - id: whyus-4
      title: Fast & Reliable Payouts
      text: Cash flow matters. We process all commissions within the first 10 business days of the month - no delays, no excuses.
      image: wallet
commission:
  title: Commission
  subtitle: Maximize Your ROI with Industry-Leading Commissions
  caption: We reward performance. Start at a competitive 20% and rapidly scale to a massive 50% Revenue Share as you bring in more players. Our transparent tiers ensure you get paid exactly what you deserve.
  note: Looking for a different model? We offer custom CPA and Hybrid deals tailored to your specific traffic sources. Contact us to build your bespoke plan.
  action:
    text: Become Partner
    modal: signup
    variant: button
    buttonVariant: primary
  button: Get Started
  variant: circular
  modifier: card--primary
  list:
    - title: RevShare
      image: countries
      list:
        - '1'
        - фыва
        - ыва
      level: 1ST LEVEL
      percentage: 20
      range: 0 - 4 FTD
      id: 1763469684552_mb4d4cc4g
    - title: RevShare
      image: stats
      list:
        - ''
      level: 2ND LEVEL
      percentage: 35
      range: 5 - 19 FTD
      id: 1763469684552_f6c4s5pc2
    - title: RevShare
      image: wallet
      list:
        - ''
      level: 3RD LEVEL
      percentage: 40
      range: 20 - 39 FTD
      id: 1763469684552_mo2jxuc70
    - title: RevShare
      image: revenue
      list:
        - ''
      level: 4TH LEVEL
      percentage: 45
      range: 40 - 59 FTD
      id: 1763469684552_odsrduhmx
    - title: RevShare
      image: wallet
      list: []
      level: 5TH LEVEL
      percentage: 50
      range: 60+ FTD
      id: 1763469684552_lst9i1xuq
testimonials:
  title: Testimonials
  subtitle: ''
  note: ''
  action:
    text: ''
  list:
    - id: testimonial-1
      text: "I’ve promoted dozens of casino brands, but FoxSlots has the best player retention by far. The massive game library (9,500+ titles) keeps my traffic engaged for months. My LTV has never been higher."
      link:
        text: Alex M. SEO Specialist
        href:
    - id: testimonial-2
      text: "Reliability is everything in this business. With FoxSlots, I never have to chase a paycheck—funds arrive within the first week of the month, every time. Plus, hitting that 50% commission tier is actually achievable here."
      link:
        text: Sarah J. Media Buyer
        href:
    - id: testimonial-3
      text: "Finally, an affiliate program with managers who actually understand traffic. My dedicated manager helped me set up a custom Hybrid deal that perfectly suits my traffic source. Support is fast, professional, and 24/7."
      link:
        text: David R. Affiliate Marketer
        href:
faq:
  title: Frequently Asked Questions
  subtitle: ''
  note: ''
  action:
    text: Affiliate Program Terms & Conditions
    modal: terms
  list:
    - id: section-1
      question: What is FoxSlots Partners?
      answer: FoxSlots Partners is the official affiliate program for the FoxSlots online casino. We connect webmasters directly with a high-converting brand, offering industry-leading commissions (up to 50% RevShare), reliable monthly payouts, and detailed real-time analytics.
      type: text
    - id: section-2
      question: How do I become a partner?
      answer: It’s simple. Click "Join Now," fill out the registration form, and verify your email. Our team reviews applications quickly - usually within 24 hours - so you can grab your tracking links and start earning immediately.
      type: text
    - id: section-3
      question: What commission models do you offer?
      answer: We primarily offer a dynamic Revenue Share model starting at 20% and scaling up to 50% based on your performance. We also offer custom CPA and Hybrid deals for experienced partners with specific traffic sources.
      type: text
    - id: section-4
      question: When and how do I get paid?
      answer: We value your cash flow. Commissions are paid within the first 5 business days of every month for the previous month's activity. We support multiple payment methods including USDT (Crypto), Bank Transfer, and Skrill.
      type: text
    - id: section-5
      question: What affiliate software do you use?
      answer: We use a premium, transparent tracking platform. You get access to a personal dashboard where you can track clicks, registrations, deposits, and Net Revenue in real-time, ensuring you never miss a conversion.
      type: text
    - id: section-6
      question: How do I get in touch?
      answer: We are here to help 24/7. You can contact our support team via the "Contacts" page, or reach out to your dedicated affiliate manager directly via Telegram, Skype, or Email once your account is active.
      type: text
contacts:
  title: Contacts
  subtitle: ''
  note: ''
  action:
    text: ''
  list:
    - id: contact-1
      type: email
      href: 'mailto:affiliates@foxslots.partners'
      text: affiliates@foxslots.partners
      icon: message
      alt: Email icon
    # - id: contact-2
    #   type: facebook
    #   href: '#'
    #   text: super_partners
    #   icon: facebook
    #   alt: super_partners icon
    # - id: contact-3
    #   type: metamask
    #   href: '#'
    #   text: super_partners
    #   icon: metamask
    #   alt: super_partners icon
    # - id: contact-4
    #   type: telegram
    #   href: '#'
    #   text: super_partners
    #   icon: telegram
    #   alt: Email icon
hero:
  title:  With FoxSlots Partners
  subtitle: Turn Your Traffic Into Revenue
  text: FoxSlots Partners is the premier affiliate program for the modern gambling market. Promote our top-tier casino brand and enjoy competitive commissions with zero hassle. We guarantee stability and 24/7 expert support to keep you winning.
  action:
    text: Start earning
    modal: signup
    variant: button
  image: banner
  imageMobile: banner-mob
footer:
  copyright: © 2026 FoxSlots Partners | All rights reserved
metadata:
  title: FoxSlots Partners - Global Casino Affiliate Program
  description: Join FoxSlots Partners affiliate program. Earn up to 50% revenue share promoting top casino brands. Fast payouts, dedicated support, and flexible commission models.
  # SEO Configuration (uncomment and fill to enable)
  # siteUrl: https://superpartners.com
  # canonicalUrl: https://superpartners.com
  # ogImage: /landing-assets/og-image.webp
  # twitterHandle: '@superpartners'
  keywords: casino affiliate, affiliate program, revenue share, CPA, hybrid deals, gambling affiliate
  author: SuperPartners
  robots: index, follow
